import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

/**
 * Add-category modal — collects a category name and returns it via
 * activeModal.close(name). The caller performs the create + toast.
 */
@Component({
    selector: 'app-category-modal',
    imports: [FormsModule],
    templateUrl: './category-modal.component.html',
    styleUrl: './category-modal.component.scss',
})
export class CategoryModalComponent {
    categoryName = '';

    constructor(public activeModal: NgbActiveModal) { }

    save(): void {
        const name = this.categoryName.trim();
        if (!name) return;
        this.activeModal.close(name);
    }
}
